/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "@kubb/plugin-client/clients/axios";
import type { RootGetQueryResponse } from "../models/RootGet.ts";
import type {
	RequestConfig,
	ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type {
	QueryKey,
	QueryClient,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const rootGetSuspenseQueryKey = () => ["v5", { url: "/" }] as const;

export type RootGetSuspenseQueryKey = ReturnType<
	typeof rootGetSuspenseQueryKey
>;

/**
 * @summary Root
 * {@link /}
 */
export async function rootGetSuspenseHook(
	config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<
		RootGetQueryResponse,
		ResponseErrorConfig<Error>,
		unknown
	>({
		method: "GET",
		url: "/",
		baseURL: "https://api.sparkscan.io",
		...requestConfig,
	});
	return res.data;
}

export function rootGetSuspenseQueryOptionsHook(
	config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
	const queryKey = rootGetSuspenseQueryKey();
	return queryOptions<
		RootGetQueryResponse,
		ResponseErrorConfig<Error>,
		RootGetQueryResponse,
		typeof queryKey
	>({
		queryKey,
		queryFn: async ({ signal }) => {
			config.signal = signal;
			return rootGetSuspenseHook(config);
		},
	});
}

/**
 * @summary Root
 * {@link /}
 */
export function useRootGetSuspenseHook<
	TData = RootGetQueryResponse,
	TQueryKey extends QueryKey = RootGetSuspenseQueryKey,
>(
	options: {
		query?: Partial<
			UseSuspenseQueryOptions<
				RootGetQueryResponse,
				ResponseErrorConfig<Error>,
				TData,
				TQueryKey
			>
		> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: typeof client };
	} = {},
) {
	const {
		query: { client: queryClient, ...queryOptions } = {},
		client: config = {},
	} = options ?? {};
	const queryKey = queryOptions?.queryKey ?? rootGetSuspenseQueryKey();

	const query = useSuspenseQuery(
		{
			...(rootGetSuspenseQueryOptionsHook(
				config,
			) as unknown as UseSuspenseQueryOptions),
			queryKey,
			...(queryOptions as unknown as Omit<UseSuspenseQueryOptions, "queryKey">),
		},
		queryClient,
	) as UseSuspenseQueryResult<TData, ResponseErrorConfig<Error>> & {
		queryKey: TQueryKey;
	};

	query.queryKey = queryKey as TQueryKey;

	return query;
}
